export const getMergedMapboxStyles = (mergedLayerId, layerConfig, currentFeature, mixStyles) => {
    const featureStyle = layerConfig.mapboxStyle;
    const layerIdToFix = currentFeature.feature.get('_originLayerId') ?? currentFeature.layer?.get('id');
    if (layerIdToFix) {
        let fixed = false;
        const fixedLayers = featureStyle?.layers.map((layer) => {
            const newLayer = {
                ...layer,
            };
            // check for mapbox layer style fixing
            if (layer.id === layerIdToFix) {
                fixed = true;
            }
            newLayer.id = layer.id === layerIdToFix ? mergedLayerId : layer.id;
            newLayer.source = mergedLayerId;
            newLayer['source-layer'] = mergedLayerId;
            return newLayer;
        });
        if (!fixed) {
            console.warn(`MapboxStyles: layer id "${layerIdToFix}" should correspond with mapbox style`);
            return null;
        }
        if (featureStyle?.sources[layerIdToFix]) {
            featureStyle.sources[`${mergedLayerId}`] = featureStyle?.sources[layerIdToFix];
        }
        if (fixedLayers && featureStyle && currentFeature) {
            return {
                ...featureStyle,
                layers: mixStyles ? [...mixStyles.layers, ...fixedLayers] : [...fixedLayers],
                sources: mixStyles
                    ? { ...mixStyles.sources, ...featureStyle?.sources }
                    : featureStyle?.sources,
            };
        }
    }
    return null;
};
//# sourceMappingURL=getMergedMapboxStyles.js.map